import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatPaginator } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CompanyService } from 'src/services/CompanyService';
import { PermissionsService } from 'src/services/PermissionsService';
import { RouterService } from '../../services/router.service';
import { IcompanyResponse } from '../Interfaces/icompany';
import { IuserPermissionsResponse } from '../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../error-state-matcher1';
import { CompanyeditComponent } from './edit/companyedit.component';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-mycompany',
  templateUrl: './mycompany.component.html'
})

export class MyCompanyComponent implements OnInit {
  formData: FormGroup;
  subRef$: Subscription;
  public companyId: string;
  matcher = new ErrorStateMatcher1();
  mensaje: string = "";
  Columns: string[] = [];
  Companies: IcompanyResponse[] = [];
  Permissions: IuserPermissionsResponse[] = [];
  permissionsList = null;
  MenuR: IuserPermissionsResponse[] = [];
  menuRList = new MatTableDataSource;
  MenuG: IuserPermissionsResponse[] = [];
  menuGList = new MatTableDataSource;
  dataList = new MatTableDataSource;
  _ShowChild = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private permissionService: PermissionsService,
    private companyservice: CompanyService,
    private routeparent: RouterService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private menuService: MenuService
  ) {
    this.formData = formBuilder.group({
      documentId: '',
      telephone1: '',
      address1: '', //[(this.companyservice.idNumber != null ? this.companyservice.idNumber:"")]
      email1: '',
      alternateCode01: '',
      sysStatus: [false]
    });
  }
  _companyName: string = "";
  companyIdN: string = "";
  _companyId: number = 0;


  ngOnInit() {
    this.routeparent.putRouter01("mycompany");
    this.mensaje = "";
    //permisos 
    this.Permissions = [];
    this.MenuG = [];
    this.MenuR = [];
    //permisos para company
    this.permissionService.getPermissionV2("MYCOMPANY").subscribe(results => {
      if (results.body.isValid) {
        for (const entry of results.body.resultData) {
          this.addPermission({
            id: entry.id, function_code: entry.function_code, code: entry.code,
            description: entry.description, type: entry.type, icon: entry.icon, link: entry.link, toolTip: entry.toolTip,
            function_class: entry.function_class, backColor: entry.backColor
          });
        }
      }
      else {
        alert(results.body.error.description);
      }
    },
      (e) => {
        this.mensaje = e.error;
        alert(e.error);
        console.log(e);
      });
    ////Menu items
    let functions: string[] = ["CC", "USER"];
    this.menuService.GetItems(functions).subscribe(results => {
      if (results.body.isValid) {
        for (const entry of results.body.resultData) {
          this.addPermission({
            id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description.trim(), type: "G",
            icon: entry.icon, link: entry.link, toolTip: entry.toolTip, function_class: entry.function_class,
            backColor: entry.backColor
          });
        }
      }
      else {
        alert(results.body.error.description);
      }
    },
      (e) => {
        if (e.status != 404) {
          this.mensaje = e.error;
          alert(e.error);
          console.log(e);
        }
      });
    ////permisos para compmore (more options)
    //this.permissionService.getPermission("COMPMORE").subscribe(results => {
    //  for (const entry of results.body) {
    //    if (entry.code == "E")
    //    {
    //      this.addPermission({
    //        id: entry.id, function_code: entry.function_code, code: entry.code,
    //        description: "MAS OPCIONES", type: 'G', icon: entry.icon, link: entry.link, toolTip: entry.toolTip
    //      });
    //      break;
    //    }
    //  }
    //},
    //  (e) => {
    //    if (e.status != 404) {
    //      this.mensaje = e.error;
    //      alert(e.error);
    //      console.log(e);
    //    }
    //  });
    //this.menuGList.sort;
    this.loadData();
    this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
    this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
    this.menuRList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuR);

  }

  loadData() {
    this.mensaje = "";
    this.companyservice.GetMyCompany(this._companyId).subscribe(results => {
      if (results.body.isValid) {
        this._companyId = results.body.resultData.id;
        this._companyName = results.body.resultData.name;
        this.companyIdN = results.body.resultData.idtypename;
        this.formData.controls['documentId'].setValue(results.body.resultData.idtypename);
        this.formData.controls['telephone1'].setValue(results.body.resultData.tele1);
        this.formData.controls['email1'].setValue(results.body.resultData.email1);
        this.formData.controls['address1'].setValue(results.body.resultData.address1);
        this.formData.controls['alternateCode01'].setValue(results.body.resultData.alternateCode01);
        this.formData.controls['sysStatus'].setValue(results.body.resultData.sysstatus == "A" ? true : false);
        this.formData.disable();


      }
    },
      (e) => {
        this.mensaje = e.error;
        console.log(e);
      });

  }

  b_more(id, name) {
    this.companyservice.putValues(id, name, true);
    this.router.navigate(['compmore']);
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    switch (permission.type) {
      case "G":
        this.MenuG.push(permission);
        break;
      case "R":
        if (permission.code == "O" || permission.code == "P") //because the presentation
          this.MenuG.push(permission);
        else
          this.MenuR.push(permission);
    }
    this.Permissions.sort((a, b) => a.description.localeCompare(b.description));
    this.MenuG.sort((a, b) => a.description.localeCompare(b.description));
    this.MenuR.sort((a, b) => a.description.localeCompare(b.description));
  }

  b_gen(functionCode,link, id, PrmCode) {
    this.companyservice.putValues(this._companyId, this._companyName, true);
    switch (functionCode) {
      case "CC":
        case "USER":
        this.router.navigate([link], { relativeTo: this.route });
        break;
      case "MYCOMPANY":
        switch (PrmCode) {
          case "O":
            link = link.replace("[class]", "1");
            this.router.navigate([link], { relativeTo: this.route });
            break;
          case "P":
            link = link.replace("[class]", "0");
            this.router.navigate([link], { relativeTo: this.route });
            break;
          case "M":
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.panelClass = "my-class";
            const dialogRef = this.dialog.open(CompanyeditComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(
              data => {
                if (data) {
                  console.log("grabado");
                  this.loadData();
                }
              }, (e) => console.log(e)
            );
            break;

          default:
            this.router.navigate([link], { skipLocationChange: true });
            break;
        }
        break;

    }
  }

  

  b_back() {
    this.router.navigate(['home']);
  }

}
